<template>
  <section>
    <div class="navPrincipal" >
      <v-flex  class="text-xs-right mr-5  pt-5">
          <v-btn
            id= "back-naranja"
            class="white--text btn-large"
            @click.native.stop="dialogAddCurso = true "
            >
            Crear Curso
          </v-btn>
      </v-flex>
    </div>
    <div class="mx-5 mt-5 mb-3 title-secondary">Cursos creados</div>

    <v-layout  column align-center justify-center v-if="cargando">
         <v-progress-circular indeterminate color="secondary" v-bind:width="2" v-bind:size="200"><img src="../../../static/Icononaranjo.png" alt="logo"  width="auto" height="100px"></v-progress-circular>
      </v-layout>
    <template v-else>
    <div align="center" class="mt-5" v-if="cursos.length==0">
                        
      <i style="font-size: 8em; color:#E0E0E0;"  class="material-icons">
        error
      </i>
      <p>No existen Cursos creados.</p>
    </div> 
    <div>
      <div class= "mx-5">
        <v-data-table
          :headers="headers"
          :items="cursos"
          class="elevation-0"
          no-data-text="No hay Evaluaciones"
          style=" border: 1px solid #EB6330; border-radius: 5px;"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center" style="width: 10px">{{ props.item.id }}</td>
            <td class="py-2 text-xs-left" style="width: 10px">
              <img height="40" :src="props.item.gallery.galleries_image"/>
            </td>
            <td class="text-xs-left">{{ props.item.cource_title }}</td>
            <td class="text-xs-center">{{ props.item.level.level_name }}</td>
            <td class="text-xs-center">{{ props.item.cource_code }}</td>
            <td  style="width: 10px">
              <v-switch
                v-model="props.item.cource_status"
                style="color: #EB6330; margin-left: 5px"
                :value="props.item.cource_status"
                hide-details
                @click="cambiarEstadoCurso(props.item.id)"
              ></v-switch>
            </td>
            <td class="justify-center layout px-0">

              <v-menu offset-y left>
                <v-btn id="btn-toolbar" icon flat  slot="activator" >
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>
                      <router-link :to="{name: 'editCource', params: { id: props.item.id }}" class="enlace">
                        Contenido
                      </router-link>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      <router-link :to="{name: 'showQualifications', params: { id: props.item.id }}" class="enlace">
                        Evaluaciones
                      </router-link>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      <router-link :to="{name: 'showMembersInCources', params: { id: props.item.id }}" class="enlace">
                        Alumnos
                      </router-link>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showDialogDeleteElement(props.item.id)">
                    <v-list-tile-title>Eliminar</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </div>
      
    </div>
    </template>
    
      <!-- DIALOG CREAR CURSO -->

    <v-dialog v-model="dialogAddCurso"   max-width="800px" height="auto" >
      <v-toolbar flat dark color="orange darken-4">
        <v-flex xs12 offset-xs1 >
          <v-card-title class="white--text pt-2 pb-0 title">CREAR CURSO</v-card-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon color="white" @click.native="dialogAddCurso = false" @click="reinicioPaso()">
          <v-icon >close</v-icon>
        </v-btn>
      </v-toolbar>
      <div>
        <v-stepper v-model="e1" non-linear  class="bordes">
          <v-stepper-header flat >
            <v-stepper-step  step="1" :complete="e1 > 1" editable ><span class="teal--text">Información básica del curso</span></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" editable><span class="teal--text">Imagen del curso</span></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat class="mb-3" height="auto">
                <v-layout row wrap>
                <v-flex xs12 sm12 md10 offset-xs1 >
                  <v-text-field 
                  class="my-1"
                  label="Titulo"
                  v-model="curso.title"
                  :counter="50"
                  required
                  autofocus
                  color="orange darken-2"
                  ></v-text-field>            
                  <v-flex xs12 mt10 mb10> 
                      <v-text-field class=""
                      name="input-3-1"  
                      label="Descripción breve"
                      multi-line
                      v-model="curso.description"
                      rows=3
                      color="orange darken-2"
                      ></v-text-field>
                  </v-flex>
                  <v-layout>
                    <v-flex xs12 sm5 md5>
                      <v-select class=""
                      label="Nivel"
                      v-model="curso.level_id"
                      :items="levels"
                      item-text="level_name"
                      item-value="id"
                      required
                      color="orange darken-2"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm5 md5 offset-xs2>
                      <v-select class=""
                      label="Categoria"
                      v-model="curso.category_id"
                      :items="categorias"
                      item-text="category_name"
                      item-value="id"
                      required
                      color="orange darken-2"
                      autocomplete
                      ></v-select>
                    </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <v-text-field class=""
                      name="input-7-1"
                      label="Acerca del curso"
                      multi-line
                      v-model="curso.about"
                      rows=3
                      color="orange darken-2"
                      ></v-text-field>
                    </v-flex>
                    <small class="">*Campos Obligatorios</small>
                    <v-layout row >
                    <v-spacer></v-spacer>
                      <v-btn color="orange darken-2" @click.native="dialogAddCurso = false" outline flat>Cancelar</v-btn>
                      <v-btn color="orange darken-2"  class="white--text" @click.native="e1 = 2">Continuar</v-btn>
                  </v-layout>
                </v-flex> 
                </v-layout>  
              </v-card>

              
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card color="white" flat class="mb-5" height="auto">
                <v-radio-group v-model="curso.gallery_id" column >
                  <v-layout row wrap>
                    <v-flex xs6 v-for="imagen in galerias" :key="imagen.id">
                      <v-layout row wrap>
                        <v-flex xs1 >
                         <v-radio 
                          class="letra-naranja"
                          :value="imagen.id">
                          </v-radio>
                        </v-flex>
                        <v-flex xs10 offset-xs1 >
                          <v-container fluid >
                          <v-layout row wrap>
                            <v-flex
                              xs12
                            >
                              <v-card flat tile>
                                <v-card-media
                                  :src="imagen.galleries_image"
                                  height="150px"
                                >
                                </v-card-media>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-container>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-radio-group> 
              </v-card>
              <v-layout row >
                <v-spacer></v-spacer>
                <v-btn class="letra-naranja" outline  flat @click.native="dialogAddCurso = false" >Cancelar</v-btn>
                <v-btn  color="orange darken-2" class="white--text"  @click="submitCurso(curso)" >Agregar</v-btn>
              </v-layout>
            </v-stepper-content>
<!--             <v-stepper-content step="3">
              <v-card color="grey lighten-1" class="mb-5" height="200px"></v-card>
              <v-btn color="primary" @click.native="e1 = 1">Continue</v-btn>
              <v-btn flat>Cancel</v-btn>
            </v-stepper-content> -->
          </v-stepper-items>
        </v-stepper>
      </div>
</v-dialog>

<v-dialog v-model="dialogDeleteElement"  max-width="500px" >
  <v-card class=" ma-0">
      <v-card-title class="balck--text center headline">¿Estas seguro que lo deseas <span class="white--text">.</span><span class="red--text"> Eliminar</span>?</v-card-title>
    <v-form  >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="red" outline @click.native="dialogDeleteElement = false" >Cancelar</v-btn>
        <v-btn class="white--text" color="red"  @click="deleteCurso()" >Eliminar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>
  </section>
</template>

<script>
import { getAllCurseOfUserService } from '@/services/GetAllCurseOfUser.service'
import { courceService } from '@/services/Cource.service'
import { nivelService } from '@/services/Nivel.service'
import { getCategoriesPerUserService } from '@/services/categoria/GetCategoriesPerUser.service'
import { galleryService } from '@/services/curso/Gallery.service'
import { changeTheStatusOfTheCourses } from '@/services/curso/ChangeTheStatusOfTheCourses.service'
export default {
  data () {
    return {
      idEspecialidad: 0,
      levels: [],
      categorias: [],
      ex7: '',
      cursos: [],
      galerias: [],
      dialogAddCurso: false,
      curso: {},
      mensaje: '',
      mode: '',
      color: '',
      snackbar: false,
      e1: 0,
      elementDelete: 0,
      dialogDeleteElement: false,
      cargando: true,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],
      headers: [
        {
          text: 'id',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        { text: '', value: 'galleries_image', align: 'center', sortable: false },
        { text: 'NOMBRE', value: 'cource_title', align: 'left', sortable: false, class: 'letra-naranja' },
        { text: 'NIVEL', value: 'level', align: 'center', sortable: false },
        { text: 'CÓDIGO', value: 'cource_code', align: 'center', sortable: false },
        { text: 'VISIBLE', value: 'cource_status', align: 'left', sortable: false },
        { text: '', value: 'actions', align: 'center', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }
  },
  mounted () {
    let vm = this
    vm.loadCursos()
    vm.loadNiveles()
    vm.loadCategoria()
    vm.loadImagenes()
  },
  methods: {
    submitCurso (model) {
      let vm = this
      courceService.save(model).then(data => {
        vm.cursos = data.body
        vm.dialogAddCurso = false
        vm.snackbar = true
        vm.curso = {}
        vm.mensaje = 'Curso Creado con Éxito!'
        vm.color = 'success'
        vm.e1 = 1
      }, response => {
        vm.loadingCurso = false
        vm.snackbar = true
        vm.curso = {}
        vm.mensaje = 'Error al crear el curso'
        vm.color = 'error'
        vm.showSnack('Error al crear el curso')
      })
    },
    showDialogDeleteElement (id) {
      let vm = this
      vm.elementDelete = id
      vm.dialogDeleteElement = true
    },
    loadCursos () {
      let vm = this
      getAllCurseOfUserService.query().then(data => {
        vm.cursos = data.body
        vm.cargando = false
      })
    },
    loadImagenes () {
      let vm = this
      galleryService.query().then(data => {
        vm.galerias = data.body
      })
    },
    loadNiveles () {
      let vm = this
      nivelService.query().then(data => {
        vm.levels = data.body
      })
    },
    reinicioPaso () {
      let vm = this
      vm.e1 = 1
    },
    loadCategoria () {
      let vm = this
      getCategoriesPerUserService.query().then(data => {
        vm.categorias = data.body
      })
    },
    cambiarEstadoCurso (id) {
      let vm = this
      changeTheStatusOfTheCourses.getById(id).then(data => {
        vm.cursos = data.body
      })
    },
    deleteCurso () {
      let vm = this
      courceService.destroy(vm.elementDelete).then(data => {
        vm.cursos = data.body
        vm.dialogDeleteElement = false
        vm.snackbar = false
        vm.color = 'success'
        // vm.mensajeToast('success', true, 'Curso Eliminadao con Éxito!')
      }, response => {
        vm.dialogDeleteElement = false
        vm.snackbar = true
        vm.mensaje = 'Error al eliminar el Curso'
        vm.color = 'error'
        vm.showSnack('Error al eliminar el Curso')
      })
    },
    verCurso (id) {
      this.$router.push({name: 'editCource', params: {id: id}})
    },
    initialize () {

    }
  }
}
</script>

<style scoped>


  .text-bold{
    font-weight: bold;
  }
  .btn-large{
    width: 20%;
  }
  
  .float_trans{
    margin-top: 5%;
    background: rgba(235, 99, 48, 0.9);
    opacity: 0.9 !important;
    filter: alpha(opacity=30); /*For IE8 and earlier*/
  }

  .letra-naranja{
    color: #EB6330;
  }

  #back-naranja{
    background-color: #EB6330;
  }

  #back-white{
    background-color: white;
    margin-bottom:2%;
  }
  
  .card-MisCursos{
      border-bottom-style: solid;
      border-color: #b71c1c;
      height: 150px !important;;
      margin-bottom: 18px;
      padding-left: 8px;
      padding-right: 8px;  
  }

  .tamaño-card{
      height: auto;
      margin-bottom: 10px;
      padding-bottom: 18px;
      padding-left: 8px;
      padding-right: 8px;  
  }

.imagen{
  max-width: 50px;
  max-height: 50px;
  height: 50px;
  width: 50px;
}

.toolbar-misCursos{
  padding: 0.2em;
  margin: 0.5em;
  background-color: #0d47a1

}
.bordes-redondeados {
  border-radius: 10px 10px 10px 10px;
-moz-border-radius: 10px 10px 10px 10px;
-webkit-border-radius: 10px 10px 10px 10px;

}

.color-fondo {
  background-color: #0d47a1
}

.text-justify{

  text-align: justify !important;
}


.truncatetitleCard {

 height: 65px; /* alto máximo del div( debe tener directa relación con la cantidad de líneas a mostrar) o puedes calcularlo de esta forma: $font-size*$line-height*$lines-to-show */

 margin: 0 auto;
 font-size: 12px;
 line-height: 1.4;
 -webkit-line-clamp: 2; /*Cantidad de líneas que desea mostrar*/
 -webkit-box-orient: vertical;
 overflow: hidden;
 text-overflow: ellipsis;
}
.truncateDescriptionCard {
display: -webkit-box;
 height: 100px; /* alto máximo del div( debe tener directa relación con la cantidad de líneas a mostrar) o puedes calcularlo de esta forma: $font-size*$line-height*$lines-to-show */

 margin: 0 auto;
 -webkit-line-clamp: 5; /*Cantidad de líneas que desea mostrar*/
 -webkit-box-orient: vertical;
 overflow: hidden;
 text-overflow: ellipsis;
}

.enlace {
  text-decoration:none;
  color: #263238;
}
div.input-group__input{
  background-color: white;
}

.bordes {
border-left: 5px solid #e65100;border-right: 5px solid #e65100;border-bottom: 5px solid #e65100;
}

.navPrincipal{
  background-image: url('../../../static/imagenPrincipal1280.png'); 
  background-repeat: no-repeat;
  background-size: 100% 100%; height: 200px
}
.title-secondary {
  letter-spacing: 5px;
  color: #e64a19;
  font-size: 25px;
  font-weight: 500;
}
.head-table-text {
  font-size: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/Curso/ShowCursosCreados.vue